import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Billing } from '@classes/billing';
import { BlobResponse } from '@classes/blob-response';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _moment from 'moment';
import { TransportCounter } from '@classes/transport-counter';
import { BillActionModel } from '@classes/bill-action-model';
import { EnvConfigurationService } from './env-configuration.service';
const moment = _moment;

@Injectable({
  providedIn: 'root'
})
export class BillingService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/billing';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getBillings(year?: number, month?: number[]): Observable<Array<Billing>> {
    let params: any = {};
    if (year) {
      params.year = year;
    }
    if (month && month.length > 0) {
      params.month = month.join(";");
    }
    return this.http.get<Array<Billing>>(this.basePath, {
      params: params
    });
  }
  downloadBillingDoc(billingDocId: string): Observable<BlobResponse> {
    const url = `${this.basePath}/downloadBillingDoc?billingDocId=${billingDocId}`;

    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(url, {
      observe: 'response',
      responseType: 'blob'
    }).pipe(map(
      (res) => {
        const tmp = this.responseToBlobReponse(res);
        return tmp;
      }
    ));
  }

  private responseToBlobReponse(res: HttpResponse<Blob>): BlobResponse {
    const contentDisposition = res.headers.get('content-disposition') || '';
    const matches = /filename=([^;]+)/ig.exec(contentDisposition);
    let filename = (matches && matches.length > 1) ? (matches[1] || 'untitled').trim() : 'untitled';
    if (filename.startsWith('"') && filename.endsWith('"')) {
      filename = filename.substring(1).slice(0, -1);
    }
    const fileContent = res.body || new Blob();
    const blob = new Blob([fileContent], { type: fileContent.type });
    const data = new BlobResponse({
      blob,
      filename
    });
    return data;
  }

  downloadBlobFile(blobResponse: BlobResponse) {
    if (blobResponse.blob.type.startsWith('image')) {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blobResponse.blob, blobResponse.filename);
        return;
      }
      const downloadURL = URL.createObjectURL(blobResponse.blob);
      const w = window.open(downloadURL, blobResponse.filename, '_blank');
      if (w) {
        w.addEventListener('load', () => {
          setTimeout(() => {
            w.document.title = blobResponse.filename || "";
          }, 100);
        }, false);

      }
    } else {
      const data = window.URL.createObjectURL(blobResponse.blob);
      const anchor = document.createElement('a');
      anchor.href = data;
      anchor.download = blobResponse.filename || "";
      anchor.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(data);
      }, 100);
    }

  }

  getTransportCounter(): Observable<TransportCounter> {
    return this.http.get<TransportCounter>(this.basePath + '/getTransportCounter');
  }

  sendMailBilling(model: BillActionModel): Observable<any> {
    return this.http.post<any>(`${this.basePath}/sendMailBilling`,
      model
    ).pipe(map(m => {
      return m
    }));
  }
  validateBilling(model: BillActionModel): Observable<any> {
    return this.http.post<any>(`${this.basePath}/validateBilling`,
      model
    ).pipe(map(m => {
      return m
    }));
  }
  cancelBilling(model: BillActionModel): Observable<any> {
    return this.http.post<any>(`${this.basePath}/cancelBilling`,
      model
    ).pipe(map(m => {
      return m
    }));
  }
}
